<dw-ui-dialog-box [title]="dialogBoxTitle" [saveDisabled]="!canSave" (saveFn)="save()">
  <div>
    <document-eligible-delivery-notes-grid
      [deliveryNotes]="eligibleDeliveryNotes()"
      [currentDeliveryNoteId]="deliveryNoteId"
      (selectionChange)="onDeliveryNoteSelectionChange($event)"
    >
    </document-eligible-delivery-notes-grid>
  </div>

  <!-- Nothing to prepare: the grid above says so on its own, an empty line preview adds nothing. -->
  @if (hasEligibleDeliveryNotes()) {
    <div class="mt-5">
      <document-lines-editor
        [title]="'Doc::CustomerQuote:ProductsAndServices' | abpLocalization"
        [columnDefs]="columnDefs"
        [rows]="linesToPreview"
        [getContextMenuItems]="getContextMenuItems"
        [treeData]="true"
        [getDataPath]="getDataPath"
        [rowClassRules]="rowClassRules"
        gridStateKey="preparationFromDeliveryNotesLinesGrid"
        [isDialogBox]="true"
        [fillRemainingHeight]="false"
        [domLayout]="'autoHeight'"
      ></document-lines-editor>
    </div>
  }
</dw-ui-dialog-box>
